var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrowsI(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 93,
    height: 20,
    viewBox: "0 0 93 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8824 0C6.96471 0 1.9951 6.66667 0 10C1.45098 9.21569 5.65882 7.76471 10.8824 8.23529C16.1059 8.70588 25.7549 16.2745 29.9265 20C33.4088 18.5882 36.0931 12.7451 37 10C32.6471 10 15.7794 0 10.8824 0Z",
    className: "Brows"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.1176 0C86.0353 0 91.0049 6.66667 93 10C91.549 9.21569 87.3412 7.76471 82.1176 8.23529C76.8941 8.70588 67.2451 16.2745 63.0735 20C59.5912 18.5882 56.9069 12.7451 56 10C60.3529 10 77.2206 0 82.1176 0Z",
    className: "Brows"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowsI);
export default __webpack_public_path__ + "static/media/Brows I.fe88d0004730674a3b91dbed9ea0f4cf.svg";
export { ForwardRef as ReactComponent };